import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

/**
 * Confirmation dialog for deleting a contact.
 */
export default function DeleteContactDialog({
  open,
  onClose,
  onConfirm,
  contact = null,
}) {
  const displayName = contact
    ? `${contact.first_name || ""} ${contact.last_name || ""}`.trim() || "this contact"
    : "this contact";

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Contact</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>{displayName}</strong>? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
